/**
 * @description
 * @author Kody
 * @date 2018-07-03
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
    resource_data: string;
}

export interface ILiveLibItem {
    id?: number;
    index?: number; // 顺序
    obj_type?: number; // 1、图片 2、小节
    pic_url?: string; // 图片地址
    live_resource_id?: number; // 小节编号
    display_status?: number; // 是否隐藏:0、隐藏 1、展示
    delete_status?: number; // 是否删除:0、不删除 1、删除
}

interface IOutput {
    status: boolean;
}

export const saveResources = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.LIVE_SAVE_RESOURCES, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
